var lib_core = require("lib-core");

/**
 * @constructor
 */
var TrayAssetUpdateTabStateMachine = function (root, model, parentName) {
    var self = this;
    this.root = root;

    this.model = model;
    this.parentName = parentName;

    var sortingKeyArchive = '';
    var sortingDirectionArchive = 'asc';

    lib_core.StateMachine.call(self, null, null, this.model.scope());

    this.sortingTransition = self.addTransition("idle","idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.UI_TRAY_TAB_SORT &&
                cEvent.data('parentName') == self.parentName &&
                cEvent.data('tabName') == self.model.name());
        },
        function(cEvent){
            var sortingKey = cEvent.data('sortingKey');
            var sortingDir = (sortingKeyArchive == sortingKey && sortingDirectionArchive == 'asc') ? 'desc' : 'asc';

            self.model.sorting_direction(sortingDir);
            self.model.sorting(sortingKey);

            sortingKeyArchive = sortingKey;
            sortingDirectionArchive = sortingDir;

        }
    );

    this.searchTransition = self.addTransition("idle","idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.UI_TRAY_TAB_SEARCH &&
                cEvent.data('parentName') == self.parentName &&
                cEvent.data('tabName') == self.model.name() );
        },
        function(cEvent){
            self.model.query(cEvent.data('val'));
        }
    );

    this.searchTransition = self.addTransition("idle","idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.UI_TRAY_TAB_TEMPLATE_CHANGE &&
                cEvent.data('parentName') == self.parentName &&
                cEvent.data('tabName') == self.model.name() );
        },
        function(cEvent){
            self.model.alternative_template(self.model.template());
            self.model.template(cEvent.data('template'));
        }
    );


};
lib_core.inherit(TrayAssetUpdateTabStateMachine, lib_core.StateMachine);

module.exports = TrayAssetUpdateTabStateMachine;
